import React from 'react'
import iframely from 'lib/iframely'
import { useClientLayoutEffect } from 'hooks'

const StoryHtml = ({ story }) => {
  // Load iframely for embeds
  useClientLayoutEffect(() => {
    iframely.load()
  }, [story.id])

  // Get story html
  const html = story.post_type_meta.standard_post.raw_content || ''

  return (
    <>
      <div className='blog-block' dangerouslySetInnerHTML={{ __html: html }} />
      <style global jsx>{`
        .blog-block p {
          font-size: 18px;
          line-height: 28px;
        }
      `}</style>
    </>
  )
}

export default StoryHtml
